/* eslint-disable no-unused-vars */

export const UCLowSymbolNames = {
    L1: `L1`,
    L2: `L2`,
    L3: `L3`,
    L4: `L4`,
    L5: `L5`,
} as const;

// eslint-disable-next-line no-redeclare
export type UCLowSymbolNames = (typeof UCLowSymbolNames)[keyof typeof UCLowSymbolNames];

export const UCHighSymbolNames = {
    M1: `M1`,
    M2: `M2`,
    M3: `M3`,
    M5: `M5`,
} as const;

// eslint-disable-next-line no-redeclare
export type UCHighSymbolNames = (typeof UCHighSymbolNames)[keyof typeof UCHighSymbolNames];

export const UCSpecialSymbolNames = {
    WILD: `W`,
    BIG_FISH: `BF`,
    F1: `F1`,
    F2: `F2`,
    F3: `F3`,
    F4: `F4`,
    F5: `F5`,
    F6: `F6`,
    F7: `F7`,
    MYSTERY: `M`,
    SCATTER: `S`,
    X: `X`,
} as const;

// eslint-disable-next-line no-redeclare
export type UCSpecialSymbolNames = (typeof UCSpecialSymbolNames)[keyof typeof UCSpecialSymbolNames];

export const UCSymbolNames = {
    ...UCLowSymbolNames,
    ...UCHighSymbolNames,
    ...UCSpecialSymbolNames,
} as const;

// eslint-disable-next-line no-redeclare
export type UCSymbolNames = (typeof UCSymbolNames)[keyof typeof UCSymbolNames];

// * if wild then full
export enum UCSymbolSize {
    X033 = 0.33,
    X075 = 0.75,
    X1 = 1,
    X2 = 2,
    X3 = 3,
    X4 = 4,
}

export enum UCDirection {
    UP = `UP`,
    DOWN = `DOWN`,
}

export enum SimpleReelModelState {
    IDLE = `IDLE`,
    START = `START`,
    SPIN = `SPIN`,
    STOP = `STOP`,
    STOPPED = `STOPPED`,
    BOUNCE = `BOUNCE`,
    NUDGE = `NUDGE`,
}

export enum BlockerStates {
    OPEN = `open`,
    CLOSED = `closed`,
}

export enum ScatterStates {
    WIN = `win`,
    LOSE = `lose`,
    NORMAL = `normal`,
    ANTICIPATION = `anticipation`,
}

export enum UCEvents {
    CLOSE_BLOCKERS = `CLOSE_BLOCKERS`,
}
